import { btnOne } from "../utils/style";


function Modal(props) {

    return(
        <div className="flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-full w-screen bg-opacity-60 z-30">
            <div className="border border-black bg-white rounded-md p-4 w-1/2">
                <div className="px-2 flex justify-end">
                    <span className="cursor-pointer font-semibold text-lg" onClick={() => props.setShowModal(false)}>x</span>
                </div>
                {
                    <props.component />
                }
                <div>
                    <button className={btnOne} onClick={() => props.setShowModal(false)}>Close</button>
                </div>
            </div>
        </div>
    )
}

export default Modal;